enum ValuerStatusEnum {
    New = 'NEW',
    QuoteReceived = 'QUOTE_RECEIVED',
    QuoteRequested = 'QUOTE_REQUESTED',
    ValuationOrdered = 'VALUATION_ORDERED',
    ValuationReceived = 'VALUATION_RECEIVED',
}

export default ValuerStatusEnum;
